import type { DemandStatus } from '../types/engineering';
import { formatDemandStatus } from '../utils/helpers/statusHelpers';

const STATUS_CSS_CLASS: Record<DemandStatus, string> = {
  BACKLOG: 'demand-status-badge--backlog',
  PLANNING: 'demand-status-badge--planning',
  PLANNING_ERROR: 'demand-status-badge--error',
  INPROGRESS: 'demand-status-badge--inprogress',
  WAITING_REVIEW: 'demand-status-badge--waiting-review',
  DONE: 'demand-status-badge--done',
  TESTING: 'demand-status-badge--testing',
  CANCELLED: 'demand-status-badge--cancelled',
};

export const DemandStatusBadge = ({ status }: { status: DemandStatus }) => (
  <span className={`demand-status-badge ${STATUS_CSS_CLASS[status] ?? ''}`}>
    {formatDemandStatus(status)}
  </span>
);
